module.exports = "<div class=\"sv-video-container\"\n     [ngStyle]=\"{top: top+'px', left: left+'px', width: width+'px', height: height+'px'}\" [hidden]=\"!shown\"\n     [class.in-preview]=\"position === 'PREVIEW'\"\n     [class.in-main]=\"position === 'MAIN'\"\n     [class.in-quick-preview]=\"position === 'QUICK_PREVIEW'\"\n     [innerHTML]=\"videoElement\">\n</div>\n{{top}},{{left}},{{width}},{{height}}\n"


//////////////////
// WEBPACK FOOTER
// /Users/sergeisidorov/Projects/streamViewer/src/app/components/video-container.component/video-container.component.html
// module id = ../../../../../src/app/components/video-container.component/video-container.component.html
// module chunks = main